/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:09:28
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-06-08 10:52:26
 * @FilePath: \crm-product\src\views\performanceCalculation\views\result_statement\annual_terminal_performance_report\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import TablePage from '@/found/components/table_page';
import Form from '../form/detail.vue';

export default {
  extends: TablePage,
  components: {
    Form,
  },
  name: 'AnnualTerminalPerformanceReportTable',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('main-list');
  },

  methods: {
    afterGetList() {
      this.tableData = this.tableData.map((item) => ({
        ...item,
        yearRate: item.yearRate ? `${item.yearRate}%` : item.yearRate,
        m1Rate: item.m1Rate ? `${item.m1Rate}%` : item.m1Rate,
        m1ConvertRate: item.m1ConvertRate ? `${item.m1ConvertRate}%` : item.m1ConvertRate,
        m2Rate: item.m2Rate ? `${item.m2Rate}%` : item.m2Rate,
        m2ConvertRate: item.m2ConvertRate ? `${item.m2ConvertRate}%` : item.m2ConvertRate,
        m3Rate: item.m3Rate ? `${item.m3Rate}%` : item.m3Rate,
        m3ConvertRate: item.m3ConvertRate ? `${item.m3ConvertRate}%` : item.m3ConvertRate,
        m4Rate: item.m4Rate ? `${item.m4Rate}%` : item.m4Rate,
        m4ConvertRate: item.m4ConvertRate ? `${item.m4ConvertRate}%` : item.m4ConvertRate,
        m5Rate: item.m5Rate ? `${item.m5Rate}%` : item.m5Rate,
        m5ConvertRate: item.m5ConvertRate ? `${item.m5ConvertRate}%` : item.m5ConvertRate,
        m6Rate: item.m6Rate ? `${item.m6Rate}%` : item.m6Rate,
        m6ConvertRate: item.m6ConvertRate ? `${item.m6ConvertRate}%` : item.m6ConvertRate,
        m7Rate: item.m7Rate ? `${item.m7Rate}%` : item.m7Rate,
        m7ConvertRate: item.m7ConvertRate ? `${item.m7ConvertRate}%` : item.m7ConvertRate,
        m8Rate: item.m8Rate ? `${item.m8Rate}%` : item.m8Rate,
        m8ConvertRate: item.m8ConvertRate ? `${item.m8ConvertRate}%` : item.m8ConvertRate,
        m9Rate: item.m9Rate ? `${item.m9Rate}%` : item.m9Rate,
        m9ConvertRate: item.m9ConvertRate ? `${item.m9ConvertRate}%` : item.m9ConvertRate,
        m10Rate: item.m10Rate ? `${item.m10Rate}%` : item.m10Rate,
        m10ConvertRate: item.m10ConvertRate ? `${item.m10ConvertRate}%` : item.m10ConvertRate,
        m11Rate: item.m11Rate ? `${item.m11Rate}%` : item.m11Rate,
        m11ConvertRate: item.m11ConvertRate ? `${item.m11ConvertRate}%` : item.m11ConvertRate,
        m12Rate: item.m12Rate ? `${item.m12Rate}%` : item.m12Rate,
        m12ConvertRate: item.m12ConvertRate ? `${item.m12ConvertRate}%` : item.m12ConvertRate,
      }));
    },
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'detail') {
        this.formConfig = {
          mainId: row.id,
        };
        this.modalConfig.title = '发货明细';
        this.openFull();
      }
    },
  },
};
